import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CartoService {

  constructor(
    private http: HttpClient
  ) { }

  protected queryData(sql: string) {
    const username = environment.carto.username;
    let url = `${environment.carto.baseUrl}${environment.carto.sqlApiEndpoint}`;
    url = url.replace('${username}', username);
    url = url.replace('${query}', encodeURIComponent(sql));
    return this.http.get(url)
      .map((json: any) => {
        if (json && json.rows) {
          return json.rows;
        } else {
          return null;
        }
      })
      .toPromise();
  }

  protected queryGeoJSON(sql: string) {
    const username = environment.carto.username;
    let url = `${environment.carto.baseUrl}${environment.carto.sqlApiEndpoint}&format=GeoJSON`;
    url = url.replace('${username}', username);
    url = url.replace('${query}', encodeURIComponent(sql));
    return this.http.get(url).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/carto.service.ts